// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"47f87c2b","188":"ccc87a27","856":"e1aaf34c"}[chunkId] + ".js";
};